<template>
  <div class="flow-info x-margin x-border-50">
    <my-head-title
      :title="$t('HT.accessInfo.title')"
      :showEdit="$hasModule(14)"
      @edit="showEdit(formData)"
    ></my-head-title>
    <div class="ul-item x-padding-info">
      <my-info-item
        :title="$t('HT.addFlow.name')"
        :optionText="false"
        :info="formData.name"
      ></my-info-item>
      <my-info-item :title="$t('HT.createdTime')" :info="formData.created_date"></my-info-item>
      <my-info-item title="QPS" :optionText="false">
        <span>{{ formData.rate }}次/</span>

        <span>{{ $opt.switchStr(formData.unit, $opt.unit) }}</span>
        <span class="my-span"> ({{ $t('HT.flowInfo.text') }})</span>
      </my-info-item>
      <my-info-item
        :title="$t('HT.apiStepOne.remark')"
        start
        :line="2"
        class="describe"
        :info="formData.remark"
      ></my-info-item>
    </div>
    <div class="tab">
      <el-tabs>
        <el-tab-pane :label="$t('HT.accessInfo.label1')">
          <ux-searchOption
            :layout="layout1"
            :data="filter1"
            @change="change"
            @input="seach1"
            @search="seach1"
            @showAdd="showBindApi"
          ></ux-searchOption>
          <ux-table
            ref="table"
            :hide-on-single-page="true"
            :data="tableData1.list"
            :columns="columns1"
            :total="tableData1.totalSize"
            :current-page.sync="filter1.page"
            @changePage="changePage1"
            @changeSize="changeSize1"
            :emptyText="$t('HT.nodata')"
            layout="total, sizes, prev, pager, next"
          ></ux-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('HT.flowInfo.label')">
          <ux-searchOption
            :layout="layout2"
            :data="filter2"
            @search="seach2"
            @input="seach2"
            @showAdd="showBindApp"
          ></ux-searchOption>
          <ux-table
            ref="table"
            :hide-on-single-page="true"
            :data="tableData2.list"
            :columns="columns2"
            :total="tableData2.totalSize"
            :current-page.sync="filter2.page"
            @changePage="changePage2"
            @changeSize="changeSize2"
            :emptyText="$t('HT.nodata')"
            layout="total, sizes, prev, pager, next"
          ></ux-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import addFlow from './template/addFlow';
import bindFlowApp from './template/bindFlowApp';
import bindFlowApi from './template/bindFlowApi';
export default {
  components: {
    addFlow,
    bindFlowApi,
    bindFlowApp
  },
  data() {
    return {
      id: this.$route.params.id, // id
      formData: {}, /// 详情
      tableData1: {
        // 已绑定API列表
        totalSize: 0,
        list: []
      },
      tableData2: {
        // 已绑定应用列表
        totalSize: 0,
        list: []
      },
      groupList: [], // 分组列表
      applyList: [], // 应用列表
      filter1: {
        env: '',
        name: '',
        page: 1,
        size: 10
      },
      filter2: {
        name: '',
        page: 1,
        size: 10
      },
      filter3: {
        name: '',
        page: 1,
        size: 100,
        status: 1
      },
      layout1: [
        // 搜索项配置
        {
          type: 'select',
          placeholder: this.$t('HT.addAccessApi.evn'),
          options: [
            {
              label: this.$t('HT.options.env1'),
              value: 'ANY'
            },
            {
              label: this.$t('HT.options.env2'),
              value: 'TEST'
            },
            {
              label: this.$t('HT.options.env3'),
              value: 'PRE'
            },
            {
              label: this.$t('HT.options.env4'),
              value: 'RELEASE'
            }
          ],
          key: 'env',
          event: 'change'
        },
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.rules.addApi.name')
        },
        {
          type: 'button',
          text: this.$t('HT.accessInfo.bindApi'),
          right: true,
          hidden: !this.$hasModule(14),
          event: 'showAdd'
        }
      ],
      layout2: [
        // 搜索项配置
        {
          type: 'button',
          text: this.$t('HT.bindApply.appId'),
          hidden: !this.$hasModule(14),
          left: true,
          event: 'showAdd'
        }
      ],
      columns1: [
        // 表格项
        {
          label: this.$t('HT.apiStepOne.name'),
          tooltip: true,
          prop: 'name'
        },
        {
          label: this.$t('HT.apiList.env'),
          tooltip: true,
          prop: 'env',
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.env);
          }
        },
        {
          label: this.$t('HT.apiStepOne.groupId'),
          prop: 'group_name',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(14),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.unbind')],
                colors: ['#0087ff'],
                event: ['unbund']
              },
              on: {
                unbund: () => {
                  this.showUnbindApi(params);
                }
              }
            });
          }
        }
      ],
      columns2: [
        {
          // 表格项
          label: this.$t('HT.unbindApply.name'),
          prop: 'app_id',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            for (let item of this.applyList) {
              if (item.id === cellValue) {
                return item.name;
              }
            }
          }
        },
        {
          label: this.$t('HT.bindFlowApp.rate'),
          prop: 'rate',
          tooltip: true,
          formatter: (row, column, cellValue) => {
            let unit = this.$opt.switchStr(this.formData.unit, this.$opt.unit);
            return cellValue + '次' + '/' + unit;
          }
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(14),
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.edit2'), this.$t('HT.unbind')],
                colors: ['#0087ff'],
                event: ['update', 'unbund']
              },
              on: {
                update: () => {
                  this.showUpdate(params);
                },
                unbund: () => {
                  this.showUnbindApp(params);
                }
              }
            });
          }
        }
      ]
    };
  },
  created() {
    this.getInfo(this.id);
    this.getInfoApiList(this.id, this.filter1);
    this.getInfoAppList(this.id, this.filter2);
  },

  mounted() {
    this.getGroupList();
    this.getApplyList(this.filter3);
  },
  updated() {
    this.$nextTick(() => {
      // document.querySelector('.ux-pagination.is-background')?.classList.remove('is-background');
    });
  },

  methods: {
    /**
     * 详情数据
     * @param {Number} id id
     */
    getInfo(id) {
      this.$uxLoading.show();
      this.$api.flow.getInfo(id).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
        }
      });
    },

    /**
     * 获取流量控制绑定的API
     * @param {Number} id id
     * @param {Object} params 参数
     */
    getInfoApiList(id, params) {
      this.$uxLoading.show();
      this.$api.flow.getInfoApiList(id, params).then((res) => {
        if (res.code == 10000) {
          this.tableData1 = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 获取流量控制绑定的应用
     * @param {Number} id id
     * @param {Object} params 参数
     */
    getInfoAppList(id, params) {
      this.$uxLoading.show();
      this.$api.flow.getInfoAppList(id, params).then((res) => {
        if (res.code == 10000) {
          this.tableData2 = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 获取分组列表
     * @param {Object} params 请求参数
     */
    getGroupList() {
      this.$api.group.getListData().then((res) => {
        if (res.code == 10000) {
          this.groupList = res.data;
        }
      });
    },

    /**
     * 获取分组列表
     * @param {Object} params 请求参数
     */
    getApplyList(params) {
      this.$api.apply.getList(params).then((res) => {
        if (res.code == 10000) {
          this.applyList = res.data;
        }
      });
    },

    /**
     * 编辑流量控制
     * @param {Object} params 详情数据
     */
    showEdit(params) {
      const title = this.$t('HT.flowInfo.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addFlow, {
            props: { data: params, tableData: this.tableData2 }
          });
        },
        confirm: (data) => {
          this.$uxLoading.show();
          this.$api.flow.putList(data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
              this.formData = data;
            }
          });
        }
      });
    },

    /**
     * 绑定API弹窗
     */
    showBindApi() {
      const title = this.$t('HT.accessInfo.bindApi');
      this.$uxModal.show({
        title,
        hideBtn: true,
        content: (h) => {
          return h(bindFlowApi, {
            props: {
              data: this.groupList
            },
            on: {
              confirm: (data) => {
                this.$api.flow.bindApis(this.id, data).then((res) => {
                  if (res.code == 10000) {
                    this.$uxModal.hide();
                    this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
                    this.getInfoApiList(this.id, this.filter1);
                  }
                });
              }
            }
          });
        }
      });
    },

    showUnbindApi(params) {
      const title = this.$t('HT.flowInfo.unbind');
      this.$uxModal.show({
        title,
        confirm: () => {
          this.$api.flow.unbindApi(this.id, params).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
              this.getInfoApiList(this.id, this.filter1);
            }
          });
        }
      });
    },

    /**
     * 绑定应用弹窗
     */
    showBindApp() {
      const title = this.$t('HT.bindApply.appId');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindFlowApp, {
            props: { data: this.formData, list: this.applyList },
            on: {}
          });
        },
        confirm: (data) => {
          this.$api.flow.bindApp(this.id, data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
              this.getInfoAppList(this.id, this.filter2);
            }
          });
        }
      });
    },

    /**
     * 修改应用弹窗
     * @param {Object} params 查询对象
     */
    showUpdate(params) {
      const title = this.$t('HT.flowInfo.editApp');

      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindFlowApp, {
            props: {
              list: this.applyList,
              appData: params,
              data: this.formData
            },
            on: {}
          });
        },
        confirm: (data) => {
          this.$api.flow.updateApp(this.id, data).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
              this.getInfoAppList(this.id, this.filter2);
            }
          });
        }
      });
    },

    /**
     * 解绑应用弹窗
     * @param {Object} params 查询对象
     */
    showUnbindApp(params) {
      const title = this.$t('HT.unbind.title');
      this.$uxModal.show({
        title,
        confirm: () => {
          this.$api.flow.unbindApp(this.id, params).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.addApi.unbindSuccess'));
              this.getInfoAppList(this.id);
            }
          });
        }
      });
    },

    /**
     * 搜索
     */
    seach1() {
      this.filter1.page = 1;
      this.getInfoApiList(this.id, this.filter1);
    },

    /**
     * 改变环境
     */
    change() {
      this.getInfoApiList(this.id, this.filter1);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize1(size) {
      this.filter1.size = size;
      this.filter1.page = 1;
      this.getInfoApiList(this.id, this.filter1);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage1(page) {
      this.filter1.page = page;
      this.getInfoApiList(this.id, this.filter1);
    },
    /**
     * 搜索
     */
    seach2() {
      this.filter2.page = 1;
      this.getInfoAppList(this.id, this.filter2);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize2(size) {
      this.filter2.size = size;
      this.filter2.page = 1;
      this.getInfoAppList(this.id, this.filter2);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage2(page) {
      this.filter2.page = page;
      this.getInfoAppList(this.id, this.filter2);
    }
  }
};
</script>

<style lang="scss" scoped>
.flow-info {
  box-sizing: border-box;

  .tab {
    padding: 0 20px 20px 20px;
  }

  .x-option-selection {
    height: auto;
    min-height: auto;
    margin-bottom: 20px;
  }

  .ul-item {
    display: flex;
    flex-wrap: wrap;
    .my-span {
      margin-left: 20px;
    }
    .info-item {
      width: 100%;
    }
  }
}
</style>
